var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLnIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_cancel 24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-828.000000, -231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "field-:-close",
    transform: "translate(466.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "field",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_cancel-24px",
    transform: "translate(358.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "holder",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_cancel",
    transform: "translate(4.000000, 4.000000)",
    fill: "#0C0C0C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292893219,1.70710678 L14.4350288,15.8492424 C14.8255531,16.2397667 15.4587181,16.2397667 15.8492424,15.8492424 C16.2397667,15.4587181 16.2397667,14.8255531 15.8492424,14.4350288 L1.70710678,0.292893219 C1.31658249,-0.0976310729 0.683417511,-0.0976310729 0.292893219,0.292893219 C-0.0976310729,0.683417511 -0.0976310729,1.31658249 0.292893219,1.70710678 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4350288,0.292893219 L0.292893219,14.4350288 C-0.0976310729,14.8255531 -0.0976310729,15.4587181 0.292893219,15.8492424 C0.683417511,16.2397667 1.31658249,16.2397667 1.70710678,15.8492424 L15.8492424,1.70710678 C16.2397667,1.31658249 16.2397667,0.683417511 15.8492424,0.292893219 C15.4587181,-0.0976310729 14.8255531,-0.0976310729 14.4350288,0.292893219 Z",
    id: "shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnIconClose);
export default __webpack_public_path__ + "static/media/ln-icon-close.3d21216cf635b9e46dc51be4ce601cf2.svg";
export { ForwardRef as ReactComponent };